export enum CounterpartyTinAccessAction {
    WRITE_GRANTED = "WRITE_GRANTED",
    WRITE_COMPLETED = "WRITE_COMPLETED",
    REVEAL_GRANTED = "REVEAL_GRANTED",
    REVEAL_COMPLETED = "REVEAL_COMPLETED",
    EXPORT_GRANTED = "EXPORT_GRANTED",
    EXPORT_COMPLETED = "EXPORT_COMPLETED",
    CLEARED = "CLEARED",
    MERGED = "MERGED",
    W9_ATTACHED = "W9_ATTACHED",
    REVIEWED = "REVIEWED",
    REVIEW_REVOKED = "REVIEW_REVOKED",
    DENIED = "DENIED",
}

export enum CounterpartyTinDenialReason {
    NOT_MEMBER = "NOT_MEMBER",
    NOT_ADMIN = "NOT_ADMIN",
    NOT_INTERACTIVE = "NOT_INTERACTIVE",
    FLAG_OFF = "FLAG_OFF",
    STEP_UP_REQUIRED = "STEP_UP_REQUIRED",
    RATE_LIMITED = "RATE_LIMITED",
    GRANT_INVALID = "GRANT_INVALID",
    BODY_INVALID = "BODY_INVALID",
    ALIAS_DECRYPT_FAILED = "ALIAS_DECRYPT_FAILED",
    TIN_NOT_SET = "TIN_NOT_SET",
    TIN_CHANGED = "TIN_CHANGED",
    ALIAS_REUSED = "ALIAS_REUSED",
    NOT_FOUND = "NOT_FOUND",
}

export enum CounterpartyTinGrantAction {
    WRITE = "write",
    REVEAL = "reveal",
}

export enum CounterpartyTinTombstoneReason {
    REPLACED = "REPLACED",
    CLEARED = "CLEARED",
    REMOVED = "REMOVED",
    MERGED = "MERGED",
    WORKSPACE_DELETED = "WORKSPACE_DELETED",
    W9_REJECTED = "W9_REJECTED",
}

export const COUNTERPARTY_TIN_COLUMNS = [
    "tinTokenCiphertext",
    "tinType",
    "tinRevisionId",
    "tinSource",
    "tinSourceDocumentId",
    "tinSourceNameMatch",
] as const;

export type CounterpartyTinColumn = (typeof COUNTERPARTY_TIN_COLUMNS)[number];
